import fetch from "../../../../utils/fetch";
import * as types from "./mutation_types";
import { Feed } from "../../../../interfaces/feed"

export const del = ({ commit, state, rootState }, item:Feed) => {
  commit(types.FEED_DELETE_TOGGLE_LOADING);

  // START:CUSTOM - generated
  let token = rootState.auth.token;
  // END:CUSTOM - generated

  return fetch(item["@id"], { method: "DELETE" }, token)
    .then(() => {
      commit(types.FEED_DELETE_TOGGLE_LOADING);
      commit(types.FEED_DELETE_SET_DELETED, item);
    })
    .catch((e) => {
      commit(types.FEED_DELETE_TOGGLE_LOADING);
      commit(types.FEED_DELETE_SET_ERROR, e.message);
    });
};

export const reset = ({ commit }) => {
  commit(types.FEED_DELETE_RESET);
};
